<template>
    <div class="bg-white h-100 rounded pa-3 d-flex flex-wrap ga-4 position-relative">
        <v-btn @click="$router.push({path: '/editProfile'})" class="rounded position-absolute top-0 left-0 ma-3" color="secondary" variant="flat" icon="icon-editt"></v-btn>
        <div class="flex-shrink-0">
            <v-avatar v-if="$auth.user.profile_picture_name" :image="$auth.user.profile_picture_name" size="120" class="rounded-lg helpical-shadow"></v-avatar>
            <v-avatar v-else image="@/assets/img/noUser.png" size="120" class="rounded-lg helpical-shadow"></v-avatar>
        </div>
        <div>
            <p class="font-weight-bold text-black mb-1">{{ $auth.user.first_name+' '+$auth.user.last_name }}</p>
            <p class="text-small text-black mb-1">{{ $auth.user.full_admin ? 'مدیر ارشد' : $auth.user.branch_admin ? 'سرپرست شعبه' : $auth.user.department_admin ? 'سرپرست دپارتمان' : $auth.user.employee ? 'کارشناس' : 'مشتری' }}</p>
            <p class="text-small text-black mb-3">تاریخ عضویت: {{ $moment($auth.user.created_at).format('jYYYY/jMM/jDD') }}</p>
            <div class="d-flex ga-4 flex-wrap">
                <div class="d-flex">
                    <v-icon class="me-2 pa-3 rounded bg-secondary" size="18">mail</v-icon>
                    <p class="text-small font-weight-medium text-primary text-truncate">{{ $auth.user.email }}</p>
                </div>
                <div class="d-flex">
                    <v-icon class="me-2 pa-3 rounded bg-secondary" size="18">phone</v-icon>
                    <p class="text-small font-weight-medium text-primary">{{ $auth.user.mobile }}</p>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
</script>
